/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: vue初期化,cloudtailor専用
 * note:
 *   - cloudtailor専用のVue初期化処理
 *   - AWSのエンドポイント情報やログアウト関数を設定する
 *   - バージョンチェック機能
 *   - cacheManageのテーブル初期化処理
 *   - その他プロジェクト固有の初期化処理(initProcess)
 *   - 全てのコンポーネントでglobalStateおよびshowLoading,removeLoadingを共有する
 * :ZNOTE:
 */

import {setAwsParams, setLogoutFunc} from '@zettant/awsUtils';
import {initProcess, tableInit} from '@projectRoot/inits';
import {normalLogout} from '@/awsCodes/awsLogout';
import {versionCheck, getAppParams} from '@zettant/commonUtils';
import {getStorageValue, updateStorageValue} from '@zettant/storageUtils';
import {setInitialized} from '@/inits';
import {globalStateKey, useGlobalState} from '@/appLogic/globalState';

setAwsParams(getAppParams().endpoint, getAppParams().appParams.userpoolName);
setLogoutFunc(normalLogout);

const versionCheckWrapper = async () => {
  const info = getStorageValue('lastVerCheck');  // 何かおかしくなった(ver.jsonが更新されないとか)ときに、リロードを繰り返さない様にするため
  const now = new Date().getTime();
  if (!info || info.time < now) {
    await versionCheck(getAppParams().version);
    updateStorageValue('lastVerCheck', {time: now+3600000});  // 1時間後にリトライ
  }
};

(async function() {
  await versionCheckWrapper();
  await tableInit();
  await initProcess();
  setInitialized();
})();

// EXP: タブがactiveになったら都度バージョンを確認する（スマホで立ち上げっぱなしのページに対応するため）
window.document.addEventListener('visibilitychange', versionCheckWrapper, false);

export default ({ app }) => {
  app.provide(globalStateKey, useGlobalState());  // EXP: 全てのコンポーネントでglobalStateおよびshowLoading,removeLoadingを共有する
};
